import script from "./AppointmentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentCard.vue?vue&type=style&index=0&id=a02ac94c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a02ac94c"]])

export default __exports__